// Experts Redux Constants
export const FETCH_EXPERTS_REQUEST = 'FETCH_EXPERTS_REQUEST';
export const FETCH_EXPERTS_SUCCESS = 'FETCH_EXPERTS_SUCCESS';
export const SET_EXPERTS_PAGE = 'SET_EXPERTS_PAGE';
export const FETCH_HOMEPAGE_EXPERTS_SUCCESS = 'FETCH_HOMEPAGE_EXPERTS_SUCCESS';
export const FETCH_EXPERT_SLOTS_REQUEST = 'FETCH_EXPERT_SLOTS_REQUEST';
export const FETCH_EXPERT_SLOTS_SUCCESS = 'FETCH_EXPERT_SLOTS_SUCCESS';
export const BOOK_SLOT_REQUEST = 'BOOK_SLOT_REQUEST';
export const BOOK_SLOT_SUCCESS = 'BOOK_SLOT_SUCCESS';
export const BOOK_SLOT_FAILURE = 'BOOK_SLOT_FAILURE';
export const SET_CURRENT_SESSION_ID = 'SET_CURRENT_SESSION_ID'; 
export const APPEND_EXPERTS_SUCCESS = 'APPEND_EXPERTS_SUCCESS';